<template>
  <div class="add">
    <div class="d d_list d_list2">
      <div class="d bar">
        <p class="a_back"><i class="iC i_back" @click="goBack"></i></p>
      </div>
    </div>
    <van-form @submit="onSubmit">
      <div class="d d_list">
        <div class="username">
          <van-field
            v-model="userName"
            name="userName"
            label="用户名"
            placeholder="请输入用户名"
          />
        </div>

        <select-item
          title="级别"
          :value="roleValue"
          :list="conditionInfo.roleList"
          :handlerSelect="selectRole"
          name="roleName"
        ></select-item>

        <comp-address
          :province="province"
          :city="city"
          :district="district"
          :selectArea="selectArea"
        ></comp-address>
      </div>

      <div class="d d_bjsm">
        <p>说明∶</p>
        <p>1.全国账号无须指定地区</p>
        <p>2.省、市级账号须指定到所属省或市</p>
        <p>3.区县级账号须指定到所属区县</p>
      </div>
      <div class="add-save">
        <van-button round block type="info" native-type="submit" class="btn btn_bc"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import CompAddress from "@/components/Address";
import SelectItem from "@/components/SelectItem";
import { getCurrentAccountInfo, editAccount } from "@/service/user";
import { tipsMsg, getLocal } from "@/common/js";

export default {
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      title: "修改成员账号",
      city: "",
      district: "",
      province: "",
      provinceCode: "100000",
      cityCode: "",
      districtCode: "",

      userName: "",
      roleId: "",
      roleValue: "请选择级别",
      conditionInfo: {},
      areaList: {}, // 数据格式见 Area 组件文档
      showRoleChoice: false,
    });

    onMounted(async () => {
      const { username } = route.query;
      proxy.$showLoading();
      const { data, code } = await getCurrentAccountInfo(username);
      console.log("data -> ", data);
      if (code === 10000 && data) {
        //
        console.log("data", data);
        const {
          user: { roleId, userName },
          base,
        } = data;
        state.conditionInfo = base;
        console.log('tate.conditionInfo -> ', state.conditionInfo)
        
        let dsjstore = getLocal("dsj_store");
        if (dsjstore) {
          dsjstore = JSON.parse(dsjstore);
        }
        let roles;
        if (dsjstore.info.roleList) {
          roles = dsjstore.info.roleList.filter((res) => {
            return roleId == res.roleId;
          });
        }
        state.roleValue = roles[0].roleName || "";
        state.userName = userName;
        Object.assign(state, data.user);
      }
      proxy.$closeLoading();
    });

    const goBack = () => {
      router.go(-1);
      // const { status, statusName } = route.query;
      // router.push({ path: "/organization/adminAccount", query: { status, statusName } });
    };
    const selectRole = (item) => {
      console.log("selectRole ->", item);
      state.roleValue = item.roleName;
      state.roleId = item.roleId;
    };

    // 选择省市区
    const selectArea = (area) => {
      console.log("selectArea", area);
      // 合并
      Object.assign(state, area);
    };
    const onSubmit = async (values) => {
      const { userName } = values;
      const {
        city,
        district,
        province,
        roleId,
        provinceCode,
        cityCode,
        districtCode,
        id,
      } = state;
      if (!userName) {
        tipsMsg("提示", "请输入用户名");
        return false;
      } 
      // else if (!REG_ZM.test(userName)) {
      //   tipsMsg("提示", "用户名必须为字母和数字的组合，区分大小写");
      //   return false;
      // }

      if (!roleId) {
        tipsMsg("提示", "请选择级别");
        return false;
      }
      if (!province || province == "不限") {
        tipsMsg("提示", "请选择省");
        return false;
      }
      if (!city || city == "不限") {
        tipsMsg("提示", "请选择市");
        return false;
      }
      if (!district || district == "不限") {
        tipsMsg("提示", "请选择区");
        return false;
      }

      const params = {
        city,
        cityCode,
        district,
        districtCode,
        province,
        provinceCode,
        roleId,
        userName,
        id,
      };
      console.log("submit -> ", params);
      const { code } = await editAccount(params);
      if (code === 10000) {
        tipsMsg("提示", "提交成功");
      }
    };
    return {
      ...toRefs(state),
      onSubmit,
      selectRole,
      selectArea,
      goBack,
    };
  },
  components: {
    CompAddress,
    SelectItem,
  },
};
</script>
<style lang="less" scoped>
.add {
  flex: 1;
  margin-bottom: 0.267rem;
  overflow: visible;
}
.add-save {
  display: flex;
  justify-content: center;
}

// .van-button {
//   font-size: 0.48rem;
//   color: #fff;
//   width: 8rem;
//   height: 1.28rem;
//   line-height: 1.28rem;
//   border-radius: 0.213rem;
// }
.van-cell {
  padding: 0;
  align-items: center;
  background-color: transparent;
  font-size: 0.48rem;
  height: 1.067rem;
  line-height: 1.067rem;
}
.van-field__control {
  font-size: 0.347rem;
  width: 82%;
  border: none;
  outline: none;
  height: 1.067rem;
  line-height: 1.067rem;
}
.van-field__label {
  font-size: 0.48rem;
}
.username {
  font-size: 0.48rem;
  height: 1.067rem;
  line-height: 1.067rem;
  padding: 0 1.067rem 0 0.4rem;
  margin: 0 0.133rem;
  background: #fff;
  // box-shadow: 0 0 0.267rem #e9f0ff;
  box-shadow: 0 0 0.267rem rgb(255 154 152 / 20%);
  border-radius: 0.107rem;
  padding: 0 1.067rem 0 0.4rem;
}
:deep(.van-field__control) {
  font-size: 0.347rem;
}
.d_list2 {
  background: #fff;
}
</style>
